module.exports = __webpack_public_path__ + "static/img/董事长致辞_banner.260783a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/董事长致辞_banner.png
// module id = vEoF
// module chunks = 1